"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _InactiveOrdersContainer = _interopRequireDefault(require("./InactiveOrdersContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _InactiveOrdersContainer["default"];